<template>
  <div class="col-12 container-card">
      <div class="card">
        <div class="card-header">Matriz de Correlação</div>
        <div class="card-body">
        <br>

            <table class="table table-bordered table-right">
                <thead>
                    <tr>
                        <th>Nome do indíce</th>
                        <th>%</th>
	
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in indices" v-bind:key="item.nomeIndexador">
                        <td>{{ item.nomeIndexador}}</td>
                        <td>
                            <img v-if="item.correlacao !== 0" :src="iconeStonksParaValor(item.correlacao)" alt="..." class="md-financial-icon" />
                            {{ formatarPorcentagem(item.correlacao) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
  </div>
</template>

<script>
import SimuladorService from "@/app/services/Simulador/simulador.service";
import UtilsService from '../../services/utils.service';
import moment from 'moment';
import { SweetModal } from "sweet-modal-vue";

export default {
  components: {
    SweetModal
  },
  props: {
    periodoSelecionado: {
      default: 0,
      type: Number
    },
    indexadoresAtivos: {
      default: [],
      type: Array
    },
    forcarRenderizacao: {
      default: 0,
      type: Number
    }
  },
  computed: {
    dataReferencia() {
      let datas = this.$store.getters.getDatasPeriodo;
      return moment(datas.maiorData ?? new Date()).format("YYYY-MM-DD");
    }
  },
  data() {
    return {
      indiceSelecionado: {
        nomeIndexador: "",
        correlacao: 0,
      },
      indices: []
    };
  },
  methods: {
    carregarDados() {
      this.indices = [];
      let indexadoresStore = this.$store.getters.getIndexadores;
      let indexadores = [];

      for (let i = 0; i < indexadoresStore.length; i++) {
        if (indexadoresStore[i].selecionado) {
          indexadores.push(Number.parseInt(indexadoresStore[i].codigoIndexador));
        }
      }

      SimuladorService.obterTabelaMatrizCorrelacao({
        token: this.$route.query.token,
        codcicl: 3, /* 3 = mensal*/
        qtdMes: 12,
        indexadores: indexadores,
        dataReferencia: this.dataReferencia,
      }).then((retorno) => {
        if (retorno.sucesso) {
          this.indices = retorno.matriz;
          //console.log(retorno.matriz[0])
        }
      });
    },
    openModal(index) {
      this.indiceSelecionado = this.indices[index];
      this.$refs["modal"].open();
    },
    formatarPorcentagem(numero) {
      return UtilsService.formatNumber(numero) + "%";
    },
    iconeStonksParaValor(valor) {
      return valor > 0
        ? require("../../assets/img/green_arrow.png") // Stonks
        : require("../../assets/img/red_arrow.png");  // Not Stonks
    },
  },
  watch: {
    indexadoresAtivos: {
      handler(n, o) {
        // Nova selecão de indexadores detectada. Recarregar tabela
        this.carregarDados();
      },
      deep: true
    },
    forcarRenderizacao: {
      handler(n, o) {
        this.carregarDados();
      },
      deep: true
    }
  }
};
</script>

<style scoped>

</style>